import { mapState } from "vuex";
import TagUsername from '@/views/spentCashback/TagUsername.vue';
import vmMachineApi from '@/api/gpuHub/vmMachines';

const daysOfWeekOptions = [
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
  { label: 'Sunday', value: 0 }
];

const billTypeOptions = [
  { label: 'Fixed Rental', value: 'fixrental' },
  { label: 'Pay As You Go', value: 'payusago' }
];

export default {
    components: {
        TagUsername
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            daysOfWeekOptions,
            billTypeOptions,
            rentalPackage: [],
            selectedDays: [],
            selectedHours: [],
            selectedRegions: [],
            selectedBillTypes: [],
            selectedUserGroup: [],
            usersIncludes: [],
            usersExcludes: [],
            selectedPackages: [],
            itemModel: { ...this.value },
            // Flag để tránh vòng lặp
            isUpdatingFromParent: false,
            isUpdatingFromChild: false
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.auth.user,
            rolesInfo: state => state.auth.roles,
            staffsInfo: state => state.staffs,
            userTagClassifyList: state => state.common.userClassifyAll
        }),
        regionList() {
            return Object.keys(this.$countryList).map(x => {
                return { id: x, text: this.$countryList[x] }
            });
        },
        machinePackageFilter() {
            return this.rentalPackage.map(x => {
                return { id: x.id, text: x.name };
            });
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(val) {
                if (!this.isUpdatingFromChild && val) {
                    this.isUpdatingFromParent = true;
                    this.itemModel = { ...val };
                    this.$nextTick(() => {
                        this.syncDataFromModel();
                        this.isUpdatingFromParent = false;
                    });
                }
            }
        },
        itemModel: {
            deep: true,
            handler(val) {
                if (!this.isUpdatingFromParent && val) {
                    this.isUpdatingFromChild = true;
                    this.syncDataToModel();
                    this.$emit('input', { ...val });
                    this.$nextTick(() => {
                        this.isUpdatingFromChild = false;
                    });
                }
            }
        },
        selectedDays() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        selectedHours() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        selectedRegions() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        selectedBillTypes() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        selectedUserGroup() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        selectedPackages() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        usersIncludes() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        },
        usersExcludes() {
            if (!this.isUpdatingFromParent) {
                this.syncDataToModel();
            }
        }
    },
    created() {        
        this.loadRentalPackage();
        // Đồng bộ dữ liệu ban đầu
        if (this.value) {
            this.itemModel = { ...this.value };
            this.$nextTick(() => {
                this.syncDataFromModel();
            });
        }
    },
    methods: {        
        loadRentalPackage() {
            vmMachineApi.getPackageList().then(response => {
                if (response.data && response.data.result === 0 && response.data.data !== null) {
                    this.rentalPackage = response.data.data.data;
                }
                else {
                    this.rentalPackage = [];
                }
            }).catch(error => {
                console.error(error);
                this.rentalPackage = [];
            });
        },
        
        // Đồng bộ dữ liệu từ model sang các arrays
        syncDataFromModel() {
            if (!this.itemModel) return;
            
            try {
                // Parse daysOfWeek
                this.selectedDays = this.itemModel.daysOfWeek ? 
                    this.itemModel.daysOfWeek.split(',').map(d => parseInt(d.trim())).filter(d => !isNaN(d)) : [];
                
                // Parse timeRanges
                this.selectedHours = this.itemModel.timeRanges ? 
                    this.itemModel.timeRanges.split(',').map(h => parseInt(h.trim())).filter(h => !isNaN(h)) : [];
                
                // Parse regionCodes
                this.selectedRegions = this.itemModel.regionCodes ? 
                    this.itemModel.regionCodes.split(',').map(r => r.trim()).filter(r => r) : [];
                
                // Parse billTypes
                this.selectedBillTypes = this.itemModel.billTypes ? 
                    this.itemModel.billTypes.split(',').map(b => b.trim()).filter(b => b) : [];
                
                // Parse userClassifyIds
                this.selectedUserGroup = this.itemModel.userClassifyIds ? 
                    this.itemModel.userClassifyIds.split(',').map(u => u.trim()).filter(u => u) : [];
                
                // Parse packageIds
                this.selectedPackages = this.itemModel.packageIds ? 
                    this.itemModel.packageIds.split(',').map(p => parseInt(p.trim())).filter(p => !isNaN(p)) : [];
                
                // Parse userIds và excludeUserIds
                this.usersIncludes = this.itemModel.userIds ? 
                    this.itemModel.userIds.split(',').map(u => u.trim()).filter(u => u) : [];
                    
                this.usersExcludes = this.itemModel.excludeUserIds ? 
                    this.itemModel.excludeUserIds.split(',').map(u => u.trim()).filter(u => u) : [];
            } catch (error) {
                console.error('Error parsing model data:', error);
            }
        },
        
        // Đồng bộ dữ liệu từ arrays sang model
        syncDataToModel() {
            if (!this.itemModel || this.isUpdatingFromParent) return;
            
            try {
                // Sync daysOfWeek
                this.itemModel.daysOfWeek = this.selectedDays.length > 0 ? 
                    ',' + this.selectedDays.join(',') + ',' : null;
                    
                // Sync timeRanges
                this.itemModel.timeRanges = this.selectedHours.length > 0 ? 
                    ',' + this.selectedHours.join(',') + ',' : null;
                    
                // Sync regionCodes
                this.itemModel.regionCodes = this.selectedRegions.length > 0 ? 
                    ',' + this.selectedRegions.join(',') + ',' : null;
                    
                // Sync billTypes
                this.itemModel.billTypes = this.selectedBillTypes.length > 0 ? 
                    ',' + this.selectedBillTypes.join(',') + ',' : null;
                    
                // Sync userClassifyIds
                this.itemModel.userClassifyIds = this.selectedUserGroup.length > 0 ? 
                    ',' + this.selectedUserGroup.join(',') + ',' : null;
                    
                // Sync packageIds
                this.itemModel.packageIds = this.selectedPackages.length > 0 ? 
                    ',' + this.selectedPackages.join(',') + ',' : null;
                    
                // Sync userIds và excludeUserIds
                this.itemModel.userIds = this.usersIncludes.length > 0 ? 
                    ',' + this.usersIncludes.join(',') + ',' : null;
                this.itemModel.excludeUserIds = this.usersExcludes.length > 0 ? 
                    ',' + this.usersExcludes.join(',') + ',' : null;
            } catch (error) {
                console.error('Error syncing to model:', error);
            }
        }
    }
}